import { type PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';

export type ScalarInputSize = 'full' | 'small';

interface ContainerProps {
    $error: boolean;
    $showUnits: boolean;
    $size: ScalarInputSize;
}

const sizeStyles: Record<ScalarInputSize, string> = {
    small: 'width: 190px; margin-right: 10px;',
    full: 'width: 540px;',
};

const Container = styled.div<ContainerProps>`
    display: flex;
    align-items: center;
    margin-bottom: 0;

    ${(p) => css`
        ${sizeStyles[p.$size]}
    `}

    /*
     * Keyed to .ant-input, not .ant-select-selector: both rules exist only for
     * TextInput, which is the sole caller passing $showUnits or $error, and it
     * renders an Input. The other three callers wrap a Select and pass neither.
     */
    ${(p) =>
        p.$showUnits &&
        css`
            .ant-input {
                border-radius: 3px 0 0 3px !important;
            }
        `}

    ${(p) =>
        p.$error &&
        css`
            .ant-input {
                background: #ffbcbc !important;
            }
        `}
`;

export type ScalarContainerProps = PropsWithChildren<{
    error?: boolean;
    showUnits?: boolean;
    size?: ScalarInputSize;
}>;

export function ScalarContainer({
    error,
    showUnits,
    size,
    children,
}: ScalarContainerProps) {
    return (
        <Container
            $error={error ?? false}
            $showUnits={showUnits ?? false}
            $size={size ?? 'full'}
        >
            {children}
        </Container>
    );
}
